import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      '& .table': {
        overflow: 'auto',
        flexGrow: 1,
        '& .MuiTableContainer-root': { overflow: 'initial' },
      },
    },
    search: {
      display: 'flex',
      padding: '8px 24px',
      alignItems: 'center',
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      justifyContent: 'space-between',
    },
    microManagement: {
      '& span, & p': {
        color: '#757575',
      },
    },
    usersList: {
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: '23px',
      paddingRight: '8px',
      alignItems: 'center',
      marginBottom: '7px',
    },
    dialogDescription: {
      padding: '16px',
      paddingLeft: '23px',
      paddingRight: '24px',
      fontFamily: 'Archivo',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '21px',
      color: '#757575',
    },
    px: {
      paddingLeft: '23px',
      paddingRight: '8px',
    },
    permissionSelect: {
      // width: '80px',
      border: '1px solid #0000003b',
      borderRadius: '4px',
      '& .MuiNativeSelect-root': {
        paddingLeft: '6px',
        paddingTop: '5px',
        paddingBottom: '5px',
        fontSize: '0.875rem',
        fontFamily: 'Archivo',
        fontWeight: 400,
        lineHeight: '15px',
      },
      '& > div': {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
          marginLeft: '6px',
          // color: '#757575',
        },
      },
      marginRight: '4px',
    },
  })
);
